$('.prices-group-js').each((key, pricesBlock) => {
  let $pricesBlock = $(pricesBlock);

  //bind language change
  $pricesBlock.find('.tabs-language-js li').click(function() {
    let languageId = parseInt(this.getAttribute('data-id'));
    setLanguage($pricesBlock, languageId);
  });
  $pricesBlock.find('.prices-indi__select select').change(function() {
    setLanguage($pricesBlock, parseInt(this.value));
  });
});

function setLanguage($pricesBlock, languageId) {
  $pricesBlock.find('.prices-indi__select select').val(languageId);
  $pricesBlock.find('.tabs-language-js li').removeClass('active');
  $pricesBlock.find(`.tabs-language-js li[data-id=${languageId}]`).addClass('active');
}

$('.group-pay-js').click(function() {
  let $this = $(this);
  let $pricesBlock = $this.closest('.prices-group-js');
  let lessonType = $this.data('id');
  let format = $this.data('format');
  let tariff = $this.data('tariff');
  let language = $pricesBlock.find('.prices-indi__select select').val();

  openPaymentForm({
    lessonType,
    format,
    tariff,
    language,
  });
});